<template>
    <v-container class="pa-0 ma-0" color="#FFA500" fluid flat style="width: 100%">

        <v-toolbar v-if="!undermanagement" id="exploretool" style="overflow:hidden" color="#FFA500" flat dense class="pb-0">
            <v-toolbar-items>
                <v-btn class="mx-0" text @click="setnavbar" color="black"><v-icon>menu</v-icon></v-btn>
                <div class="pa-1 mx-5 black--text menuhead" text tile>SELECT SURVEY</div>
                <v-menu class="pa-0 ma-0" flat offset-y :key="this.$store.state.updatecount">
                    <template v-slot:activator="{ on }">
                        <v-btn color="#FFA500" class="py-0 my-0" v-on="on"><v-icon color="black" class="pr-5 mr-0">filter</v-icon>{{filtertitle}}</v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-for="(item, index) in filteritems" :key="index" @click="setFilter(item)">
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-menu class="pa-0 ma-0" flat offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn color="#FFA500" class="py-0 my-0" v-on="on"><v-icon color="black" class="pr-5 mr-0">sort</v-icon>{{sorttitle}}</v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-for="(item, index) in sortitems" :key="index" @click="setSort(item)">
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar-items>
        </v-toolbar>


        <v-card flat color="#FFD375">

            <v-card v-if="undermanagement" flat color="#FFD375">
                <v-container class="pa-2 ma-2" style="height: 5%;">
                    <v-menu class="pa-0 ma-0" style="position:absolute; left:45px; top:100px;"  flat offset-y :key="this.$store.state.updatecount">
                        <template v-slot:activator="{ on }">
                            <v-btn color="#FFA500" class="py-0 my-0" v-on="on"><v-icon color="black" class="pr-5 mr-0">filter</v-icon>{{filtertitle}}</v-btn>
                        </template>
                        <v-list>
                            <v-list-item v-for="(item, index) in filteritems" :key="index" @click="setFilter(item)">
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-menu class="pa-0 ma-0" style="position:absolute; left:255px; top:100px;" flat offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn color="#FFA500" class="py-0 my-0" v-on="on"><v-icon color="black" class="pr-5 mr-0">sort</v-icon>{{sorttitle}}</v-btn>
                        </template>
                        <v-list>
                            <v-list-item v-for="(item, index) in sortitems" :key="index" @click="setSort(item)">
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-container>
            </v-card>

            <v-card color="#FFD375" id="listcard" class="pa-0  my-5 overflow-y-auto" style="width: 600px" flat tile>
                <v-list two-line class="bckgrnd pa-0 ma-0" flat>
                    <v-content>
                        <v-list-item-group v-model="item" color="#FFD375">
                            <v-list-item v-for="(survey, i) in surveys" :key="i">
                                <v-row :class="rowClass(survey)" @click='rowClicked(survey)'>
                                    <v-col cols="7">
                                        <v-list-item-content>
                                            <v-list-item-title class="boldtext" v-text="survey.Name"></v-list-item-title>
                                            <v-list-item-subtitle class="smalltext" v-text="surveyDetail(survey)"></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col cols="5" class="text-right">
                                        <v-container>
                                            <v-list-item-icon class="px-2 py-0 ma-0" v-if="canDelete(survey)" @click='deleteClicked()'>
                                                <v-icon color="#000000">delete_forever</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-icon v-if="survey.IsSelected" class="pa-0 ma-0" @click='exploreClicked()'>
                                                <v-icon color="#000000">explore</v-icon>
                                            </v-list-item-icon>
                                        </v-container>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                        </v-list-item-group>
                    </v-content>
                </v-list>
            </v-card>

        <SurveyPopup v-bind:editsurvey=editsurvey v-model="showSurveyPopup" />
        </v-card>
    </v-container>
</template>

<script>

    //<v-card id="listcard" class="pa-0  my-5 overflow-y-auto" flat style="width: 400px; height: 500px" tile>

    import router from '@/router';
    import SurveyPopup from '@/views/Manage/Surveys/SurveyPopup';

    export default {
        mounted: function () {
            this.resizeCard(null);
            this.surveys = [];
            this.$store.state.surveys.forEach(survey => {
                survey.IsSelected = false;
                this.surveys.push(survey);
            });
            this.setSort(this.xparam);

            //this.$nextTick(function () {
                //window.addEventListener('resize', this.resizeCard);
            //});

        },
        data: () => ({
            sortitems: [
                { title: 'Latest first', prop: 'StartTime', dir: 'Down'},
                { title: 'Earliest first', prop: 'StartTime', dir: 'Up' },
            ],
            sorttitle: 'Sort...',
            filteritems: [
                { title: 'Show all'},
            ],
            filtertitle: 'Show all',
            item: null,
            groupdata: {},
            surveys: [],
            xparam: { title: 'Latest first', prop: 'StartTime', dir: 'Down' },
            selectedsurvey: null,
            editsurvey:null,
            showSurveyPopup: false,
        }),
        components: {
            SurveyPopup,
        },
        methods: {
            resizeCard(event) {
                var hx = document.documentElement.clientHeight - 88;
                var crd = document.getElementById("listcard");
                if (crd != null) {
                    crd.style.width = "400px";
                    crd.style.height = "" + hx + "px";
                }
            },
            setnavbar() {
                this.$store.state.navpage.setnavbar();
            },
            meetsFilter(survey) {
                if (this.filtertitle === "Show all")
                    return true;
                return false;
            },
            surveyDetail(survey) {
                var str = "( ";
                str += survey.MediaCount + " item"
                if (survey.MediaCount != 1)
                    str += "s"
                str += " (" + Number(survey.MediaSize / 1000000).toFixed(2) + " MB)";
                str += " )";
                return str;
            },
            setFilter(param) {
                this.filtertitle = param.title;
                this.surveys = [];
                this.$store.state.surveys.forEach(survey => {
                    if (this.meetsFilter(survey))
                        this.surveys.push(survey);
                });
                this.setSort(this.xparam);
            },
            setSort(param) {
                this.sorttitle = "Sort by " + param.title;
                this.xparam = param;
                if (param.dir === 'Up')
                    this.surveys.sort((a, b) => a[this.xparam.prop] < b[this.xparam.prop] ? -1 : 1);
                else
                    this.surveys.sort((a, b) => a[this.xparam.prop] > b[this.xparam.prop] ? -1 : 1);
            },
            rowClicked(survey) {
                if (this.selectedsurvey != null)
                    this.selectedsurvey.IsSelected = false;
                survey.IsSelected = true;
                this.selectedsurvey = survey;
                this.$store.state.selectedsurvey = survey;
            },
            editClicked() {
                this.editsurvey = this.selectedsurvey;
                this.$store.state.editsurvey = this.editsurvey;
                this.showSurveyPopup = true;
            },
            deleteClicked() {
                this.$root.$confirm('Confirm', 'Are you sure you want to delete this survey?', { color: '#FFA500' }).then((confirm) => {
                    if (confirm) {
                        this.$store.dispatch('cutSurvey', this.selectedsurvey);
                    }
                })
            },
            exploreClicked() {
                this.$store.state.exploresurvey = this.selectedsurvey;
                this.$store.state.pagememory = [];
                var dbid = this.$store.state.databaseid;
                var uid = this.$store.state.user.uid;
                if (this.selectedsurvey.Remote) {
                    dbid = this.selectedsurvey.DatabaseID;
                    uid = this.selectedsurvey.CreatorID;
                }
                this.$store.dispatch('listenForSurveyData', { dbid:dbid, uid:uid});
                this.selectedsurvey.IsSelected = false;
                this.selectedsurvey = null;
                this.$store.state.selectedsurvey.IsSelected = false;
                this.$store.state.selectedsurvey = null;
                this.setSort(this.xparam);
                this.$store.state.heading = "Explore";
                this.$router.push({ path: 'explore' })
            },
            isMySurvey(survey) {
                if (survey.CreatorID === this.$store.state.user.uid)
                    return true;
                else
                    return false;
            },
            isMySurveySelected(survey) {
                if ((this.isMySurvey(survey)) && (survey.IsSelected))
                    return true;
                else
                    return false;
            },
            rowClass(survey) {
                if (survey.IsSelected)
                    return 'selectedtile';
                else {
                    if (this.isMySurvey(survey))
                        return 'greentile';
                    else
                        return 'pinktile';
                }
            },
            canDelete(survey) {
                if ((survey.IsSelected) && (this.$store.state.deletesurveys))
                    return true;
                else
                    return false;
            }
        },
        computed: {
            undermanagement() {
                return this.$store.state.undermanagement;
            },
            noSurveys() {
                if (!this.surveys)
                    return true;
                if (this.surveys.length < 1)
                    return true;
                else
                    return false;
            }
        }
    }
</script>

<style scoped>
    .tile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        border-color: black;
        background: #FFD375;
    }

        .tile:hover {
            background: #FFC733;
        }

    .tile:active {
        background: yellow;
    }

    .selectedtile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        background: #FFA500;
    }

    .greentile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        background: #86F499;
    }

    .pinktile {
        margin: 0px;
        padding: 0px;
        margin-top: 0px;
        margin-bottom: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        background: #F49C86;
    }

    .bckgrnd {
        background: #FFD375;
    }

    .boldtext {
        color: black;
        font-size: large;
        font-weight: bold;
    }

    .smalltext {
        color: darkslategray;
        font-size: small;
        margin-top: 4px;
    }

    .menuhead {
        font-size: 1.5em;
        font-weight: bold;
    }
</style>

